import { useEffect, useState, useRef } from "react";
import { connect, ConnectedProps } from "react-redux";
import { useParams } from "react-router-dom";
import { AnyAction, bindActionCreators, Dispatch } from "redux";
import { thunkFindAllUsers, thunkGetUserOtpDevices } from "../../store/actions/UserActions";
import { IStore } from "../../store/IStore";
import { UserDto } from "../../store/models/user/UserDto";
import MenuLayout from "../app/MenuLayout";
import UserForm from "./UserForm";
import { UserStatus } from "./UserStatus";
import { useTranslation } from "react-i18next";

const defaultUser: UserDto = {
  firstName: "",
  lastName: "",
  userGroups: [],
  status: UserStatus.ACTIVE,
};
const UserFormPage = (props: ThunkProps) => {
  const { users, thunkFindAllUsers, thunkGetUserOtpDevices } = props;
  const { id } = useParams<"id">();
  const user = users.find((user) => user.userNumber === id) ?? defaultUser;
  const { t } = useTranslation();
  const [initialLoadComplete, setInitialLoadComplete] = useState(false);
  const otpDevicesFetchedRef = useRef<string | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      if (id) {
        await thunkFindAllUsers();
        setInitialLoadComplete(true);
      }
    };
    
    fetchData();
  }, [id, thunkFindAllUsers]);

  useEffect(() => {
    const fetchOtpDevices = async () => {
      if (id && initialLoadComplete && user.userNumber && otpDevicesFetchedRef.current !== user.userNumber) {
        otpDevicesFetchedRef.current = user.userNumber;
        await thunkGetUserOtpDevices(user);
      }
    };
    
    fetchOtpDevices();
  }, [id, initialLoadComplete, user, thunkGetUserOtpDevices]);

  return (
    <MenuLayout headline={id ? t("user.editUser") : t("user.createUser")}>
      <UserForm user={user} showMfa={!!(id && initialLoadComplete)} />
    </MenuLayout>
  );
};

const mapStateToProps = (state: IStore) => ({
  users: state.users.users,
});

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => 
  bindActionCreators(
    {
      thunkFindAllUsers,
      thunkGetUserOtpDevices,
    },
    dispatch
  );

const connector = connect(mapStateToProps, mapDispatchToProps);
type ThunkProps = ConnectedProps<typeof connector>;
export default connector(UserFormPage);
